// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-container {
  padding: 2em;
  background-color: rgb(255, 255, 255) !important;
  border-radius: 25px !important;
  margin-bottom: 30px !important;
  width: 96% !important;
}
.article-container h2 {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 20px/30px;
  font-weight: 900;
  letter-spacing: 0px;
  color: #151515;
  opacity: 1;
}
.article-container h4 {
  margin-top: 10px;
}

.article-item {
  padding: 20px;
  border-top: 25px;
  margin-bottom: 25px;
}

.no-border-container {
  padding: 0px !important;
  margin: 0px !important;
}

.article-item-border {
  border-bottom: 1px solid #cccccc;
  padding: 30px;
}

.description {
  font-family: "Lato", sans-serif;
  font-size: 16px !important;
  color: #151515 !important;
}

.description li {
  font-size: 16px !important;
}

.text {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  height: auto;
  background-color: rgb(255, 255, 255);
}

.image-content {
  max-height: 350px;
}

.seeArticle {
  font-size: 20px;
  color: rgb(18, 101, 183);
  font-family: "Lato", sans-serif !important;
}

.image-preview {
  align-self: center;
  background-color: rgb(255, 255, 255);
}

.pagination-articles {
  background-color: rgb(255, 255, 255) !important;
  display: flex !important;
  align-items: flex-end !important;
  align-content: flex-end !important;
  justify-content: flex-end !important;
  align-self: flex-end !important;
  padding-right: 20px;
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/articleListContainer/articleListContainer.scss","webpack://./src/sass/layout/articleListContainer/articleListContainer.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,YAAA;EACA,+CAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;ACFF;ADGE;EACE,gBAAA;EACA,0CETG;EFUH,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACDJ;ADGE;EACE,gBAAA;ACDJ;;ADKA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;ACFF;;ADKA;EACE,uBAAA;EACA,sBAAA;ACFF;;ADKA;EACE,gCAAA;EACA,aAAA;ACFF;;ADKA;EACE,+BAAA;EACA,0BAAA;EACA,yBAAA;ACFF;;ADKA;EACE,0BAAA;ACFF;;AAEA;EDIE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,8BAAA;ECFF,uBAAA;EACE,yBAAyB;EDI3B,YAAA;EACE,oCAAA;ACFF;;ADKA;EACE,iBAAA;ACFF;;AAEA;EACE,eAAe;EDIjB,wBAAA;EACE,0CAAA;ACFF;;AAEA;EDIA,kBAAA;EACE,oCAAA;ACFF;;AAEA;EDIE,+CAAA;EACA,wBAAA;EACA,gCAAA;EACA,kCAAA;ECFF,oCAAA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.article-container {\n  padding: 2em;\n  background-color: $White !important;\n  border-radius: 25px !important;\n  margin-bottom: 30px !important;\n  width: 96% !important;\n  h2 {\n    text-align: left;\n    font-family: $Font;\n    font-size: 20px/30px;\n    font-weight: 900;\n    letter-spacing: 0px;\n    color: #151515;\n    opacity: 1;\n  }\n  h4 {\n    margin-top: 10px;\n  }\n}\n\n.article-item {\n  padding: 20px;\n  border-top: 25px;\n  margin-bottom: 25px;\n}\n\n.no-border-container {\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.article-item-border {\n  border-bottom: 1px solid #cccccc;\n  padding: 30px;\n}\n\n.description {\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px;\n  color: #151515 !important;\n}\n\n.text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  height: auto;\n  background-color: $White;\n}\n\n.image-content {\n  max-height: 350px;\n}\n\n.seeArticle {\n  font-size: 20px;\n  color: $LinkColor;\n  font-family: $Font;\n}\n\n.image-preview {\n  align-self: center;\n  background-color: $White;\n}\n\n.pagination-articles {\n  background-color: $White !important;\n  display: flex !important;\n  align-items: flex-end !important;\n  align-content: flex-end !important;\n  justify-content: flex-end !important;\n  align-self: flex-end !important;\n  padding-right: 20px;\n  margin-top: 1rem;\n}\n",".article-container {\n  padding: 2em;\n  background-color: rgb(255, 255, 255) !important;\n  border-radius: 25px !important;\n  margin-bottom: 30px !important;\n  width: 96% !important;\n}\n.article-container h2 {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 20px/30px;\n  font-weight: 900;\n  letter-spacing: 0px;\n  color: #151515;\n  opacity: 1;\n}\n.article-container h4 {\n  margin-top: 10px;\n}\n\n.article-item {\n  padding: 20px;\n  border-top: 25px;\n  margin-bottom: 25px;\n}\n\n.no-border-container {\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.article-item-border {\n  border-bottom: 1px solid #cccccc;\n  padding: 30px;\n}\n\n.description {\n  font-family: \"Lato\", sans-serif;\n  font-size: 16px !important;\n  color: #151515 !important;\n}\n\n.description li {\n  font-size: 16px !important;\n}\n\n.text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  height: auto;\n  background-color: rgb(255, 255, 255);\n}\n\n.image-content {\n  max-height: 350px;\n}\n\n.seeArticle {\n  font-size: 20px;\n  color: rgb(18, 101, 183);\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.image-preview {\n  align-self: center;\n  background-color: rgb(255, 255, 255);\n}\n\n.pagination-articles {\n  background-color: rgb(255, 255, 255) !important;\n  display: flex !important;\n  align-items: flex-end !important;\n  align-content: flex-end !important;\n  justify-content: flex-end !important;\n  align-self: flex-end !important;\n  padding-right: 20px;\n  margin-top: 1rem;\n}/*# sourceMappingURL=articleListContainer.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
